import { toast as reactToast } from 'react-toastify'

import { fromGraphql } from './strings'

const position = 'bottom-left'

const toast = {
  info: (message, callback) => {
    message && message.message
      ? reactToast.info(fromGraphql(message.message), {position}) // standard Error object
      : reactToast.info(message, {position})
    if (callback) callback()
  },

  error: (message, callback) => {
    message && message.message
      ? reactToast.error(fromGraphql(message.message), {position}) // standard Error object
      : reactToast.error(message, {position})
    if (callback) callback()
  }
}

export default toast


// WEBPACK FOOTER //
// ./src/utils/toast.js